import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

import Providers from '@/components/Providers'
import AppRoutes from '@/routes'

import './styles/globals.css'
import './assets/iconify-icons/generated-icons.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <Providers direction='ltr'>
        <AppRoutes />
      </Providers>
    </BrowserRouter>
  </React.StrictMode>
)
